import strFunc from '@/lib/lyg/string';
import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";

function OrderDetailRowArea(props: any) {
  let myProps = {
    row_data: {},
    is_show_detail: false,
    ...props
  };
  let row_data = myProps.row_data;
  let select_order_product_type = ShopFunc.select_order_product_type;

  const get_detail_tags = (order_det_arr: any) => {
    let show_order_det_arr:any=[];
    if(myProps.is_show_detail){
      show_order_det_arr=order_det_arr;
    }else{
      if(order_det_arr.length>0){
        show_order_det_arr.push(order_det_arr[0]);
      }
    }

    let detail_tags = show_order_det_arr.map((item: any, index: number) => {
      let product_type_text = "";
      for (let i = 0; i < select_order_product_type.length; i++) {
        let tmp_obj = select_order_product_type[i];
        if (tmp_obj.value == item.a_product_type) {
          product_type_text = tmp_obj.text;;
          break;
        }
      }
      return (
        <div key={index} className="mb-2 last:mb-0">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-2 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-2 whitespace-nowrap overflow-x-auto">
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium text-white ${
                product_type_text === '온라인' ? 'bg-emerald-600' : 'bg-indigo-600'
              }`}>
                {product_type_text}
              </span>
              <span className="font-semibold text-gray-800 text-sm" title={item.a_product_name} style={{minWidth:"240px"}}>
                {item.a_product_name}
              </span>
              <span className="text-sm text-gray-600 flex items-center gap-1">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {item.a_buy_user_name}
              </span>
              <span className="text-sm text-gray-700 flex items-center gap-1 bg-white px-1.5 py-0.5 rounded">
                <span className="text-gray-500 text-xs">수량</span>
                <span className="font-semibold text-blue-600">{strFunc.comma(item.a_amount)}</span>
              </span>
              <span className="text-sm font-semibold flex items-center gap-1 bg-green-100 text-green-800 px-1.5 py-0.5 rounded">
                <span className="text-green-600 text-xs">가격</span>
                <span>{strFunc.comma(item.a_price_sum)}원</span>
              </span>
            </div>
          </div>
        </div>
      );
    });
    return detail_tags;
  };

  const get_show_val_str = () => {
    let show_val_str: any = "";

    show_val_str = get_detail_tags(row_data.order_det_arr);

    return show_val_str;
  };



  return (
    <div className='text-left'>
      {get_show_val_str()}
    </div>
  );
};
export default OrderDetailRowArea;